import React from 'react';
import { Button } from '@oscar/theme';
import { EditFilled } from '@ant-design/icons';
import { ListProps, ListItemProps } from '../types';
import { isNull } from 'lodash';
import { Collapse } from 'antd';
import { FormContext } from '@oscar/form/dist/formContext';
import { useFormContext } from '@oscar/form';
import useStatus from 'views/pages/create-instrulation/hooks/useStatus';
const { Panel } = Collapse;

const RenderChildComponent = React.memo(({ component, ...props }: any) => {
  return component ? component(props) : <></>;
});

export const List: <T = any>(props: ListProps<T>) => JSX.Element = props => {
  const {
    title,
    data,
    onClickItem,
    onCreateItem,
    onItemRenderer,
    selectedField,
    emptyList,
    readOnly,
    formState,
    limit,
    keyField,
    createButtonComponent,
  } = props;
  const [statusRequest] = useStatus();
  const [formContext] = useFormContext();
  console.log(statusRequest?.status, statusRequest?.state);

  const { submitQAQCsTime } = formContext.selectors?.getInitalValue() || {};
  const checkPaintingFinal = (statusRequestParam: any) => {
    return (
      statusRequestParam?.status?.includes?.('PENDING_PAINTING') &&
      statusRequestParam?.state === 'EDIT' &&
      submitQAQCsTime?.submittedTime ===
        submitQAQCsTime?.needToSubmittedTime - 1
    );
  };

  const getText = (key: any) => {
    switch (key) {
      case 'saP_NotificationId':
        return 'Notification details from the search result';
      case 'steelId':
        return 'Add Request from the search result to the list or click Create New to create a new one';
      case 'id':
        return 'Add Work Item to the list';
      default:
        return 'Add Request from the search result to the list or click Create New to create a new one';
    }
  };

  const isEdited = formContext.form?.getFieldValue('isEdited');
  return (
    <div className="list">
      {keyField === 'id' && !readOnly ? (
        ''
      ) : (
        <div className="list-title">{title}</div>
      )}
      <div className="list-items">
        {keyField === 'id' && !readOnly ? (
          <Collapse accordion bordered={false}>
            <Panel header={title} key="1">
              {data ? (
                data
                  .filter((item: any, j) => {
                    if (isEdited) {
                      return (
                        (!item?.isProposalList &&
                          data
                            .map((val: any) => val.WorklistID)
                            .indexOf(item?.id)) ||
                        item?.new
                      );
                    } else {
                      return !item?.isProposalList || item?.new;
                    }
                  })
                  .map((item: any, i) => {
                    return (
                      <div style={{ position: 'relative' }}>
                        <Notification
                          className={
                            item?._field?.key === selectedField?.key
                              ? 'active'
                              : ''
                          }
                          key={
                            keyField && item?.[keyField]
                              ? item?.[keyField]
                              : item?._field?.key
                          }
                          item={item}
                          field={item?._field}
                          onClickItem={onClickItem}
                          onItemRenderer={onItemRenderer}
                        />
                        <Button
                          type="primary"
                          style={{
                            position: 'absolute',
                            bottom: '5px',
                            width: '30px',
                            height: '30px',
                          }}
                          disabled={item?.Updated || !!item?.worklistID}
                          icon={
                            (statusRequest?.status ===
                              'PENDING_REINSTATEMENT' ||
                              checkPaintingFinal(statusRequest) ||
                              (!checkPaintingFinal(statusRequest) &&
                                statusRequest?.status ===
                                  'PENDING_PAINTING')) && <EditFilled />
                          }
                          onClick={() => {
                            formContext.form?.setFieldsValue({
                              flag: 'EDIT',
                              idFromEdit: item.id,
                              indexFromEdit: i,
                              isEdited: true,
                            });
                            if (onCreateItem) onCreateItem();
                          }}
                        />
                      </div>
                    );
                  })
              ) : (
                <div className="list-items-notice">{emptyList}</div>
              )}
              {data.length === 0 && (
                <div
                  className="empty-notification"
                  style={{
                    padding: '10px',
                    width: '95%',
                    margin: '20px 20px auto auto',
                    textAlign: 'center',
                    color: '#8D8D8D',
                  }}
                >
                  {getText(keyField)}
                </div>
              )}
            </Panel>
          </Collapse>
        ) : (
          <>
            {data ? (
              data
                .filter((item: any) => !item?.isProposalList)
                .map((item: any) => {
                  return (
                    <Notification
                      className={
                        item?._field?.key === selectedField?.key ? 'active' : ''
                      }
                      key={
                        keyField && item?.[keyField]
                          ? item?.[keyField]
                          : item?._field?.key
                      }
                      item={item}
                      field={item?._field}
                      onClickItem={onClickItem}
                      onItemRenderer={onItemRenderer}
                    />
                  );
                })
            ) : (
              <div className="list-items-notice">{emptyList}</div>
            )}

            {data.length === 0 && (
              <div
                className="empty-notification"
                style={{
                  padding: '10px',
                  width: '95%',
                  margin: '20px 20px auto auto',
                  textAlign: 'center',
                  color: '#8D8D8D',
                }}
              >
                {getText(keyField)}
              </div>
            )}
          </>
        )}

        {(!limit || (limit && data.length < limit)) &&
          !readOnly &&
          (createButtonComponent ? (
            createButtonComponent(props)
          ) : (
            <Button
              disabled={formState === 'Create'}
              className="create-button"
              type="secondary"
              size="middle"
              onClick={() => {
                formContext.form?.setFieldsValue({
                  flag: '',
                  idFromEdit: '',
                  indexFromEdit: '',
                });
                if (onCreateItem) onCreateItem();
              }}
              style={{ marginBottom: '10px' }}
            >
              CREATE NEW
            </Button>
          ))}
      </div>
    </div>
  );
};

const Notification: <T = any>(
  props: ListItemProps<T>,
) => JSX.Element = props => {
  const { item, onClickItem, onItemRenderer, field, className = '' } = props;
  return (
    <div
      className={`list-items-item ${className}`}
      onClick={() => onClickItem && onClickItem(item, field)}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          margin: '2px 0',
          flex: 1,
        }}
      >
        {onItemRenderer(item)}
      </div>
    </div>
  );
};

export default List;
